// 组件
import importImg from '@/components/importImg.vue'
// 接口
import * as shopsApi from '@/services/shops.js'
import * as shopCategoriesApi from '@/services/shop-categories.js'
import * as shopSubCategoriesApi from '@/services/shop-sub-categories.js'
// 其他
import dataDictionary from '@/utils/data-dictionary.js'
import constant from '@/utils/constant.js'
import verifyRules from '@/utils/verify-rules/index.js'
import loading from '@/utils/loading.json'

export default {
  components: {
    importImg
  },
  data () {
    return {
      constant,
      dataDictionary,
      verifyRules: verifyRules(this),
      shopList: [],
      categoriesList: [],
      mainForm: {
        categorieSelect: {
          loading: false
        },
        data: {
          online: true,
          shop_id: null,
          name: null,
          name_en: null,
          remote_image_url: null,
          rank: null,
          category_sub_categories_attributes: []
        }
      }
    }
  },
  mounted () {
    const _this = this
    _this.setGlobalLoading(true)
    shopsApi.getShopsSimpleList().then(res => {
      _this.setGlobalLoading(false)
      _this.shopList = res.data.shops
    }).catch(() => _this.setGlobalLoading(false))
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = this.$loading(loading) : this.$store.state.app.loading.close()
    },
    getCategoriesDefaultData () {
      return {
        shop_category_id: null
      }
    },
    handleMainFormCategoriesAddBtnClick () {
      const _this = this
      _this.mainForm.data.category_sub_categories_attributes.push(_this.getCategoriesDefaultData())
    },
    handleMainFormSubCategoriesItemDelBtnClick (index) {
      const _this = this
      _this.mainForm.data.category_sub_categories_attributes.splice(index, 1)
    },
    handleMainFormImgChange (fileData) {
      const _this = this
      if (fileData && fileData.length > 0) {
        _this.mainForm.data.remote_image_url = fileData[0].url
      } else {
        _this.mainForm.data.remote_image_url = null
      }
    },
    handleMainFormShopSelectChange (val) {
      const _this = this
      _this.categoriesList = []
      _this.mainForm.data.category_sub_categories_attributes = []
      _this.mainForm.categorieSelect.loading = true
      shopCategoriesApi.getSimpleListByShopId({
        shop_id: val
      }).then(res => {
        _this.mainForm.categorieSelect.loading = false
        _this.categoriesList = res.data.shop_categories
      }).catch(() => {
        _this.mainForm.categorieSelect.loading = false
      })
    },
    handleMainFormCancelClick () {
      const _this = this
      _this.$router.go(-1)
    },
    handleMainFormSubmitClick () {
      const _this = this
      _this.$refs.mainForm.validate((valid) => {
        if (valid) {
          const csca = _this.mainForm.data.category_sub_categories_attributes
          for (const key in csca) {
            if (!csca[key].shop_category_id) {
              _this.$message({
                type: 'warning',
                message: _this.$t('form.product.selectACategory')
              })
              return false
            }
          }
          let requestParams = {}
          Object.assign(requestParams, _this.mainForm.data)
          requestParams = {
            shop_sub_category: {
              ...requestParams
            }
          }
          _this.setGlobalLoading(true)
          shopSubCategoriesApi.postShopSubCategories(requestParams).then(() => {
            _this.setGlobalLoading(false)
            _this.$message({
              type: 'success',
              message: _this.$t('message.operateSuccess')
            })
            setTimeout(() => {
              _this.$router.push({
                name: 'goodsManagerSubCategoriesList'
              })
            }, constant.ROUTER_CHANGE_INTERVAL)
          }).catch(() => _this.setGlobalLoading(false))
        } else {
          this.$message.error(this.$t('message.formIsRequire'))
          return false
        }
      })
    }
  }
}
